if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        let options = {
          slidesPerView: 1,
          direction: this.getDirection(),
          freeMode: false,
          longSwipes: false,
          mousewheel: true,
          mousewheel: {
            // if function # PRODUCT PAGE DESKTOP CUSTOM IMAGE SCROLL in global.js have issues, try this
            releaseOnEdges: false,
            //noMousewheelClass: "product__media-main",
            sensitivity: 0.1,
            thresholdTime: 500,
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            type: 'bullets',
            clickable: true,
          },
          scrollbar: {
            el: this.querySelector('.swiper-scrollbar'),
            hide: false,
            draggable: true,
            verticalClass: 'disabled-vertical',
          },
          on: {
            resize: () => {
              this.swiper.changeDirection(this.getDirection());
            },
            slideChangeTransitionEnd: () => {
              let params = this.swiper.params;
              params.mousewheel.releaseOnEdges = false;
              this.swiper.update();
              let productSwiper = this.swiper;
              setTimeout(function () {
                if (productSwiper.isEnd || productSwiper.isBeginning) {
                  params.mousewheel.releaseOnEdges = true;
                  productSwiper.update();
                }
              }, 100);
            },
          },
        };
        this.swiper = new Swiper(this.querySelector('.swiper'), options);
      }

      swiperUpdateSlides() {
        this.swiper.updateSlides();
      }

      swiperUpdate() {
        this.swiper.update();
      }

      swiperSlideTo(index) {
        this.swiper.slideTo(index);
      }

      getDirection() {
        let windowWidth = window.innerWidth;
        let direction = windowWidth < 990 ? 'horizontal' : 'vertical';

        return direction;
      }
    }
  );
}
